import React,{useEffect,useState} from 'react';

import List from './sms_api/List'
import Create from './sms_api/Create'

function SMS(){
	const [viewPage, setViewPage] = useState('');

	useEffect(()=>{
		getPage('list')
	},[])

	const getPage = (pageNumber)=>{
		if(pageNumber === 'list'){
			setViewPage(<List getPage={getPage}/>)
		}
		if(pageNumber === 'create'){
			setViewPage(<Create getPage={getPage}/>)
		}
	}

	return(
		<>
			{viewPage}			
		</>
	);
}

export default SMS;